import { render, staticRenderFns } from "./WorkDetails.vue?vue&type=template&id=a61fe3ea&lang=pug&"
import script from "./WorkDetails.vue?vue&type=script&lang=js&"
export * from "./WorkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports